import React from "react";

import {
  Column,
  Columns,
  Heading,
  Hidden,
  Section,
  Stack,
  Text,
} from "@origin-digital/ods-core";

import { Transcript, Video } from "src/components/Video";

import content from "./content.json";

export const MediaSection: React.FC = () => (
  <Section>
    <Hidden above="sm">
      <Stack space="large">
        <Stack space="medium">
          <Heading variant="h2" align="left">
            {content.heading}
          </Heading>
          <Heading variant="h3" align="left">
            {content.subheading}
          </Heading>
          <Video content={content.video} />
        </Stack>
        <Stack space="large">
          <Transcript content={content.video} />

          <Text>{content.text}</Text>
        </Stack>
      </Stack>
    </Hidden>

    <Hidden below="md">
      <Stack space="xxlarge">
        <Heading variant="h2" align="center">
          {content.heading}
        </Heading>
        <Columns>
          <Column>
            <Stack space="medium">
              <Heading variant="h3">{content.subheading}</Heading>
              <Text>{content.text}</Text>
            </Stack>
          </Column>
          <Column>
            <Stack space="medium">
              <Stack space="small">
                <Video content={content.video} />
                <Transcript content={content.video} />
              </Stack>
            </Stack>
          </Column>
        </Columns>
      </Stack>
    </Hidden>
  </Section>
);
